var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"warp"},[_c('div',{staticClass:"ql-editor",domProps:{"innerHTML":_vm._s(_vm.htmlData)}},[_vm._v(_vm._s(_vm.htmlData))])])}
var staticRenderFns = []

export { render, staticRenderFns }